export enum CardColor {
    Blue = "blue",
    Pink = "pink",
}